import type { Suggestion } from '../aiSuggestionsPluginType';
import { REMIX_PLACEHOLDER_CONTAINER_TESTID } from './remixPlaceholder';
import { getRemixSourceLocalIds, isSuggestedRemix } from './remixSuggestion';

/** Block nodes render their localId as `data-local-id`, so the source block is queryable. */
function findLastSourceBlock(suggestion: Suggestion): Element | null {
	const localIds = getRemixSourceLocalIds(suggestion);
	const lastLocalId = localIds[localIds.length - 1];
	if (!lastLocalId) {
		return null;
	}
	// Ignored via go/ees005
	// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
	return document.querySelector(`[data-local-id="${CSS.escape(lastLocalId)}"]`);
}

/**
 * Bring a suggested remix's result into view: the placeholder while it generates, else the last
 * source block it is anchored to. Both sit where the infographic lands, unlike the card's anchor.
 */
export function scrollRemixIntoView(suggestion: Suggestion): boolean {
	if (!isSuggestedRemix(suggestion)) {
		return false;
	}

	// The placeholder renders directly after the last source block and carries its own scroll
	// margin, so prefer it; once it is gone the source block is the closest stable landmark.
	// Ignored via go/ees005
	// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
	const placeholder = document.querySelector(
		`[data-testid="${REMIX_PLACEHOLDER_CONTAINER_TESTID}"]`,
	);
	const target = placeholder ?? findLastSourceBlock(suggestion);
	if (!target) {
		return false;
	}

	target.scrollIntoView({ behavior: 'smooth', block: 'start' });
	return true;
}
